import { ReactNode, useEffect } from 'react';
import { createPortal } from 'react-dom';
let openModals = 0;
let previousOverflow = '';
/** Render above the application layout, outside transformed cards and scrolling lists. */
export default function ModalPortal({ children }: { children: ReactNode }) {
    useEffect(() => {
        if (openModals++ === 0) { previousOverflow = document.body.style.overflow; document.body.style.overflow = 'hidden'; }
        return () => { if (--openModals === 0) document.body.style.overflow = previousOverflow; };
    }, []);
    return createPortal(<div className="modal-root">{children}</div>, document.body);
}
